import { useAppSelector } from 'Store/index';
import { useMyServiceContext } from '../..';
import { getMySQUsageStatus } from 'Routes/MyService/util';
import { Container, Item } from 'Components/Grid';
import { Error, CheckCircle } from '@mui/icons-material';
import colors from '../../../../../config/theme/colors';
import MyServiceAccess from './MyServiceAccess';

/** Draws the text "Potilaalla on StellarQ My -palvelu käytössä" */
export const PatientMyServiceStatus = (): React.JSX.Element => {
  const { fm } = useMyServiceContext();
  const patientMySQStatus = useAppSelector(s => s.myapp.mysqUserId);
  const delegates = useAppSelector(s => s.patient.delegates);
  const platform = useAppSelector(s => s.session.platforms?.selected);
  const mysqStatus = getMySQUsageStatus(patientMySQStatus, delegates);

  return (
    <Container style={{ marginBottom: platform === 'ms' ? (mysqStatus ? '2.5rem' : '5rem') : '3.2rem' }}>
      <Item xs={5}>
        {!mysqStatus ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Error style={{ color: colors.warning.default, margin: '0 0.5rem 0 0.3rem' }} />
              <span style={{ color: colors.tertiaryText, fontWeight: 600 }}>
                {fm('myService.patientNotUsingMyService')}
              </span>
            </div>
          </>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircle style={{ color: colors.success, margin: '0 0.5rem 0 0.3rem' }} />
            <span style={{ color: colors.tertiaryText, fontWeight: 600 }}>
              {fm(`myService.${mysqStatus}UsingMyService`)}
            </span>
          </div>
        )}
      </Item>
      <Item xs={7} style={platform === 'ms' ? { paddingLeft: '2rem' } : { justifyItems: 'flex-end' }}>
        <MyServiceAccess platform={platform} />
      </Item>
    </Container>
  );
};

PatientMyServiceStatus.displayName = 'PatientMyServiceStatus';
